import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mas"
}
const _hoisted_3 = {
  key: 1,
  class: "mas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "btn btn-icon btn-sm btn-warning",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggleAdvanced')), ["prevent"]))
        }, [
          (_ctx.isAdvanced)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2, _toDisplayString(_ctx.iconIsAdvanced), 1))
            : (_openBlock(), _createElementBlock("i", _hoisted_3, _toDisplayString(_ctx.iconIsNotAdvanced), 1))
        ])
      ]))
    : _createCommentVNode("", true)
}